export enum ActionType {
  logout = "user/logout",
  login = "user/loginAsync/fulfilled",
}
